module.exports = "<td>{{name}}</td> <td>{{compute_model.name}}</td> <td> <a href=javascript:; class=edit-item-btn>编辑</a> <a href=javascript:; class=remove-item-btn>删除</a> </td>";


//////////////////
// WEBPACK FOOTER
// ./app/components/bisystem/canvas/main/cells/cell/original.data/advanced/item/original.advanced.item.html
// module id = 4907
// module chunks = 50